import { getLogger } from '@thyme/libs/src/logging/logger'
import { msToHours } from '@thyme/libs/src/time/convert'
import { ref } from 'vue'
import { RouteLocationNormalized } from 'vue-router'

export const lastAssetLoad = ref(new Date())
export const MAX_HOURS_BETWEEN_ASSET_LOADS = 12
/**
 * Add a guard to reload the page (and assets) if it has been too long since the last load.
 * @param to
 * @param from
 */
export function maybeReloadGuard(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized // eslint-disable-line @typescript-eslint/no-unused-vars
) {
  const now = new Date()
  const hoursSinceLastAssetLoad = msToHours(
    now.getTime() - lastAssetLoad.value.getTime()
  )
  if (hoursSinceLastAssetLoad > MAX_HOURS_BETWEEN_ASSET_LOADS) {
    getLogger().info(
      `Reloading page to get new assets (hours since last load (${hoursSinceLastAssetLoad})`
    )
    window.location.replace(to.fullPath)
  }
  return true
}
